// Mock data for professional portfolio/brag book

export const personalInfo = {
  name: "Narek Onanyan",
  title: "IT Support Engineer I",
  tagline: "Delivering dependable IT support and infrastructure stability with 6 years at Amazon and 20+ years of IT experience.",
  email: "nareko@amazon.com",
  phone: "+1 (818) 268-8354",
  location: "Los Angeles, CA",
  linkedin: "linkedin.com/in/narekonanyan",
  github: "github.com/narekonanyan"
};

export const skillsSummary = "I bring over 6 years of hands-on experience across IT infrastructure, cloud computing, networking, and technical support. I have worked extensively with AWS, Windows Server, Linux, Office 365, Azure AD, and network systems while supporting incident management, video surveillance solutions, wireless deployments, and hardware troubleshooting.";

export const skills = {
  coreSkills: [
    { name: "AWS", category: "Core Technical Skills" },
    { name: "Networking", category: "Core Technical Skills" },
    { name: "Linux", category: "Core Technical Skills" },
    { name: "Windows Server", category: "Core Technical Skills" },
    { name: "Cloud Computing", category: "Core Technical Skills" },
    { name: "Office 365", category: "Core Technical Skills" },
    { name: "Azure AD", category: "Core Technical Skills" },
    { name: "Python", category: "Core Technical Skills" }
  ],
  practicalSkills: [
    { name: "Wireless Networking", category: "Practical & Specialized Skills" },
    { name: "Video Surveillance", category: "Practical & Specialized Skills" },
    { name: "Technical Support", category: "Practical & Specialized Skills" },
    { name: "Incident Management", category: "Practical & Specialized Skills" },
    { name: "IT Infrastructure", category: "Practical & Specialized Skills" },
    { name: "Storage Systems", category: "Practical & Specialized Skills" },
    { name: "Computer Hardware", category: "Practical & Specialized Skills" },
    { name: "Troubleshooting", category: "Practical & Specialized Skills" }
  ]
};

export const careerDevelopment = {
  currentRole: "I am a multi-certified (AWS, CCNA, MCSE, VCP) IT Support Engineer with 20+ years of cross-platform experience in Systems Administration, Networking, and Technical Support.",
  certifications: [
    { 
      name: "AWS Certified Solutions Architect – Associate", 
      date: "2024", 
      status: "Active",
      credlyUrl: "https://www.credly.com/badges/bfaacd5d-81a0-42d2-8b06-6db5741c7452"
    },
    { 
      name: "AWS Certified SysOps Administrator – Associate", 
      date: "2023", 
      status: "Active",
      credlyUrl: "https://www.credly.com/badges/d435f414-784d-4a3f-9513-ef6eb77eb61c"
    }
  ],
  careerGrowth: "I have expressed interest in the Manager Apprentice Program (MAP) as a potential next step in my career journey. The MAP program aligns with my goal to explore leadership opportunities while continuing to contribute technical value to the organization. Unless better opportunities are available or suggested to advance from my current role in OTS organization."

};

export const technicalLeadership = {
  tenure: "During  the past 6 years of my tenure, my extensive knowledge of Amazon's IT infrastructure has helped me quickly identify and resolve complex network issues across our fulfillment centers, delivery stations, and grocery sites.",
  achievements: [
    "Gained in-depth knowledge in Tennisball N19 and FFN-X network stacks",
    "Resolved numerous network and IT-related issues",
    "Handled challenging technical problems to ensure systems reliability",
    "Started developing innovative ideas utilizing modern agentic AI environments"
  ]
};

export const extendedRoles = [
  {
    title: "CML1 Approver",
    description: "Being an L1 reviewer since 2021 I have maintained a high level of productivity working concurrently on nodal tasks and covering for L1 queues to make sure the projects are being done in a timely manner in SoCal region.",
    impact: "Reviewed 474+ MCMs in 2025, preventing potential outages and intrusive events."
  },
  {
    title: "Technical Interviewer",
    description: "Over the past year conducted 5 technical interviews for IT Support Engineer I positions. Assess candidates' technical skills.",
    impact: "Interviewed 80+ candidates over the past 6 years, contributing to numerous of successful hires"
  },
  {
    title: "ITSU and OE Metrics Compliance Lead",
    description: "Overseeing ITSU (and OE metrics soon) compliance metrics and reporting. Sending out communication reports on a weekly basis.",
    impact: "Consolidating data from various compliance dashboards and reporting to ledership for widespread visibility"
  },
  {
    title: "Regional Technical Lead",
    description: "Provided technical guidance and leadership for multiple regional projects icluding OTS Solutions Off-Corp Phase 2 (Outpost).",
    impact: "Led coordination across different sites and PMs, improving deployment consistency to meet projects' deadline"
  }
];

export const featuredInnovation = {
  title: "Device Repair Manager - Demo Software",
  description: "Utilized an agentic development environment to develop a full-stack web application that improves the Zebra TC scanner repair process. The system follows a modern 3-tier architecture (React frontend, Node.js/Express API backend, SQLite database via Prisma ORM) and was built with clean, scalable structure in mind.",
  technologies: ["React", "Vite", "SQLite", "Node.js", "Express", "REST APIs"],
  impact: "Recorded a pilot demonstration video shocasing how the potential software can eliminate technician's time wasted on repeat offender devices.",
  features: [
    "Instant lookup tool with Serial number search",
    "Real-time repeat offender detection",
    "Analytics dashboard to support metrics",
    "Structured data import and export "
  ],
  images: [
    "/device-manager-1.jpg",
    "/device-manager-2.jpg", 
    "/device-manager-3.jpg"
  ]
};

export const innovations = [
  {
    title: "MCM Template Finder",
    description: "A simple MCM Template Finder page with instant search results",
    technologies: ["XWiki", "Transclude", "CSS"],
    impact: "No more hunting through different Wikis and Policies to locate the right template. The MCM Template Finder has 80+ template owned by different teams. This cuts down template search time from long minutes to mere seconds, saving engineers and technicians countless hours each week."
  },
  {
    title: "INC URL Generator",
    description: "A lightweight Tempermonkey script with a collapsable UI where users can simply paste any Service Now Incident ID to instantly generate the corresponding direct URL.",
    technologies: ["JavaScript", "HTML", "CSS", "Tempermonkey API"],
    impact: "This simple automation has reduced ticket navigation time from minutes to just seconds per incident, saving an estimated 2-3 hours per week for teams handling high ticket volumes that are coming from SIM-T. The tool is valuable for engineers working across multiple platforms."
  },
  {
    title: "Engineer Toolkit",
    description: "Engineer Toolkit is a web page within Amazon's internal Wiki environment to centralize commonly used engineering tools across the region and nationwide.",
    technologies: ["XWiki", "HTML", "CSS", "Image Optimization"],
    impact: "Improved operational readiness by giving engineers quick access to vetted, commonly used tools needed for daily tasks and on-call rotations. Standardized equipment across the region, promoting consistency and reducing procurement confusion. Cost-effective solution without additional infrastructure."
  }
];

export const starStories = [
  {
    principle: "SAX5 Hylas Remediation",
    situation: "SAX5 Hylas had a lot of critical alarms that needed to be remediated.",
    task: "Collect information and do a deep dive, to come up with a plan and remediate all the critical alarms in Hylas.",
    action: "I started drafting and running Config Push MCMs for devices that were reachable so Hylas could clear the alarms. I was using LAN template and had a lot of back and forth with CMBR and LAN team ensuring that what I am doing is the right way towards the resolution of the issues. Then I worked with RME team to trace down the ISA3K and IE2K devices in AutoSal that were showing as down in Hylas. After long back and forth, I was able to have RME to open the control panels, and I have identified a network cable plugged into a wrong port that was causing the false alarms in Hylas showing the ISA3K and downstream devices offline.",
    result: "After all the remediation steps completed, Hylas cleared all the alarms and the site had 0 critical alarms."
  },
  {
    principle: "DLX5 Decoder Addition",
    situation: "DLX5 Sr Station Manager has requested a decoder with video wall to be added into the manager's office.",
    task: "The task was to identify all the necessary steps to get this request fulfilled.",
    action: "Requested a quote from LVC for data drops, ran escort MCM and worked with IES and Ops to complete the drops. Ordered the latest supporting Bosch Video Decoder 7000. Created IP address reservation based on decoder's MAC address. Worked with SIG to add the video wall in the NVR with proper layout.",
    result: "The result was customer's satisfaction with this custom setup that is not very common at AMZL facilities."
  }
];

export const accomplishments = {
  summary: [
    "Migrated 50+ applications to AWS with zero downtime",
    "Reduced infrastructure costs by 40% through optimization initiatives",
    "Improved system reliability from 99.5% to 99.95% uptime",
    "Led team of 5 engineers on critical cloud modernization project",
    "Established infrastructure standards adopted by 200+ engineers"
  ],
  showChart: false, // Set to false to hide the chart
  projects: [
    {
      name: "SAX5 MDF PDU False Readings",
      description: "One of the MDF PDUs had false readings on the screen causing Hylas to trigger false alarms. Scheduled a custom MCM to suppress affected devices and fully power-cycle the PDU.",
      technologies: ["Vendor Communication", "Custom MCM", "Ownership"],
      impact: "This non-standard workaround has resolved the false readings and cleared Hylas alarms.",
      timeline: "Q3 2025"
    },
    {
      name: "DLX5 MDF AC Unit Swap",
      description: "One of the MDF AC units at DLX5 had a faulty compressor. Communicated with Rittal to ship out a brand new unit and have a technician to come over for the swap.",
      technologies: ["Vendor Communication", "Escort MCM", "RMA"],
      impact: "The faulty unit was swapped successfully providing redundant cooling of MDF unit.",
      timeline: "Q2 2025"
    },
    {
      name: "DLX5 Bosch Decoder / Video Wall setup",
      description: "Worked with Ops, LVC, SIG to add a vide wall security dashboard in site lead's office that required constant communication with all stakeholders.",
      technologies: ["Video Surveillance", "Vendor Work", "Procurement"],
      impact: "Having a video wall setup in manager's office increases the visibility of truck yard to reduce incidents.",
      timeline: "Q3 2025"
    },
    {
      name: "DLX9 Scanless Stow",
      description: "Worked on 2 OnLogic Thin Client Setup for Scanless Stow project, coordinated LVC escort for data drops, worked on VLAN/IP assignments, DORA reservations, etc.",
      technologies: ["PM Coordination", "Escorts", "TC Deployment"],
      impact: "Led the project to it's successfull rollout without any IT-related issues.",
      timeline: "Q4 2025"
    },
    {
      name: "Single Phase UPS Lifecycle",
      description: "Worked on UPS lifecycle project running MCMs to replace UPS units and UPS batteries, as well as running calibration MCMs at multiple sites.",
      technologies: ["UPS", "Lifecycle", "Liquidation"],
      impact: "Deployed fresh UPS' and UPS batteries to eliminate end of life UPS failures",
      timeline: "Q4 2025"
    },
    {
      name: "SoCal Fresh Sites Pinnacle Pilot",
      description: "Assigned to work on A to Z punch anywhere tablets deployment for more than 15 Amazon Fresh sites in SoCal area, from far west side up to San Diego.",
      technologies: ["Amazon Fresh", "Pilot", "Deployment"],
      impact: "Replacing the old Kronos time clocks and provisioning Pinnacle tablets standardized punch anywhere device monitoring across region.",
      timeline: "Q3 2025"
    }
  ],
  metrics: [
    { label: "Projects Completed", value: 15 },
    { label: "CML1 Reviews", value: 474 },
    { label: "SEV2 Pages", value: 60 },
    { label: "Phone Screens", value: 5 }
  ]
};

export const operationalExcellence = [
  {
    category: "Cross-Regional Communication",
    activities: [
      "constantly communicate with other engineers and share my knowledge on anything they might need help with such as server deployment/replacement, troubleshooting Local Area and Wireless Network connectivity issues, working with Control Panels and ISA3k/IE2k Firewalls and Switches, working with cameras, etc.",
    ]
  },
  {
    category: "Knowledge Sharing",
    activities: [
      "I constantly provide guidance and assistance to local technicians, frequently acting as a resource for troubleshooting and problem-solving, as well as assisting with CM-related questions."
    ]
  },
  {
    category: "Emergency Response",
    activities: [
      "Responded to high severity pages for SAX5 (SEV1/SEV2) several times driving to sites at night without being oncall. Provided onsite support and worked with LAN/WAN/NPA teams on various issues such as WAN status critical, core equipment being down, etc."
    ]
  },
  {
    category: "Mentoring and Guidance ",
    activities: [
      "I constantly collect, document and share my findings or troubleshooting steps that are not documented in Amazon Wiki or Policy, and I share with my team or region-wide slack channels or posting in our shared folders."
    ]
  }
];

export const certifications = [
  {
    name: "AWS Certified Solutions Architect - Associate",
    issuer: "Amazon Web Services",
    date: "September 2024",
    credentialId: "AWS-SAP-12345",
    status: "Active"
  },
  {
    name: "AWS Certified SysOps Administrator - Associate",
    issuer: "Amazon Web Services",
    date: "June 2023",
    credentialId: "AWS-DOP-67890",
    status: "Active"
  },
  {
    name: "Cisco Certified Network Associate - Security",
    issuer: "Cisco",
    date: "May 2018",
    credentialId: "AWS-SEC-11223",
    status: "Expired"
  },
  {
    name: "MCSE: Cloud Platform and Infrastructure",
    issuer: "Microsoft",
    date: "December 2018",
    credentialId: "CKA-44556",
    status: "Active"
  },
  {
    name: "MCSA: Windows Server 2012",
    issuer: "Microsoft",
    date: "October 2016",
    credentialId: "TF-77889",
    status: "Active"
  }
];

export const training = [
  {
    title: "AI for Business | Learning Path",
    details: [
      "Artificial Intelligence for Project Managers",
      "Learning XAI Explainable Artificial Intelligence",
      "Using AI to Generate Business Analysis Deliverables",
      "Your Top AI Questions Answered, AI Literacy for Everyone"
    ]
  },
  {
    title: "Build with AI: Create Data Analytics Dashboards with Lovable",
    details: [
      "Getting Started with Lovable",
      "Build Your First Dashboard",
      "Create Professional Executive Views"
    ]
  },
  {
    title: "Build with AI: Create a Local AI Agent with Gemma",
    details: [
      "Getting Started: Gemma 3 Setup",
      "Designing and Planning Your Agent",
      "Implementing the Tools for the Agent to Use",
      "Creating Prompts for the Agentic Workflow",
      "Finishing Your App",
      "Extending Your App to Be Multimodal"
    ]
  },
  {
    title: "Cybersecurity Awareness: AI",
    details: [
      "Understanding AI and AI-Enhanced Threats",
      "Ethics, Privacy, and Responsible Use",
      "Defending against AI-Enhanced Threats"
    ]
  },
  {
    title: "Programming Foundations: Software Testing/QA",
    details: [
      "The Role of QA",
      "Test Planning",
      "Types of Testing QA Focuses On",
      "Bug Reporting"
    ]
  },
  {
    title: "Test Automation Foundations",
    details: [
      "Test Types",
      "How to Approach Automation",
      "Testing Tools",
      "Decide What to Automate",
      "Adopt Test Automation"
    ]
  },
  {
    title: "Strategic Thinking",
    details: [
      "Setting the Stage for Strategic Thinking",
      "Developing Your Strategic Thinking",
      "Technical proposal writing"
    ]
  },
  {
    title: "Leading without Formal Authority ",
    details: [
      "The Foundations of Leading without Formal Authority",
      "Leadership Language and Behavior",
      "High-Stakes Situations"
    ]
  }
];

export const shoutouts = [
  {
    from: "Fares Srouji",
    message: "Narek's support is top notch. He takes action immediately, and complements that with the experience and knowledge to make the right decisions. DLX5 is very thankful for his impeccable assistance.",
    date: "Senior Station Manager",
    badgeImage: "/badge-1.png" // Replace with your badge image path
  },
  {
    from: "Andrea Jewett",
    message: "A huge shout out to our incredible IT teams and RME for their outstanding work on the CA Timeclock Project! Their exceptional support and dedication ensured that we successfully implemented the timeclocks right on schedule. The team's bias for action and collaborative spirit were truly impressive. This project's success is a testament to their expertise and commitment. Great job, everyone!",
    date: "Sr TiPM",
    badgeImage: "/badge-2.png" // Replace with your badge image path
  },
  {
    from: "Nicholas Harrison",
    message: "Narek, my team really appreciates you going above and beyond to help amazon monitor and reduce water usage at Ops sites! You kept in constant contact regarding installation of datadrops at your site and obtaining network data to allow our equipment to function properly. I really appreciate how courteous and responsive you've been on this project. Thanks for all you do!",
    date: "Sr. Technical Program Manager",
    badgeImage: "/badge-1.png" // Replace with your badge image path
  }
];

export const performanceReview = {
  rating: "Exceeds Expectations",
  highlights: [
    "Consistently delivers high-impact projects that drive business value",
    "Demonstrates exceptional technical leadership and mentorship",
    "Proactively identifies and resolves complex infrastructure challenges",
    "Strong collaboration across teams and regions",
    "Innovation mindset evidenced by Gen AI infrastructure assistant project"
  ],
  areasOfStrength: [
    "Ownership",
    "Customer Obsession",
    "Bias for Action",
    "Deliver Results",
    "Dive Deep",
    "Are Right A Lot",
    "Earn Trust",
    "Hire and Develop the Best",
    "Insist on the Highest Standards"
  ],
  managerQuote: "You bring a lot of strengths to your work at Amazon. What stands out for me is: Narek is seen as an informal leader by our regions engineering staff. He has run large builds, excels at hiring and mentoring, troubleshoots complex issues with authority. He owns projects large and small, takes care of all aspects of his job proactively, and continually delivers results for the team and customers alike.",
  peerFeedback: [
    "I've had the opportunity to work with Narek for several years now. Narek has consistently been a very valuable member of the team, bringing thoughtfulness and expertise. As one of the senior members of the CML1 team, Narek has been a great resource, always ready to assist with reviews and guide newer team members through the CM review process. Narek's contributions during team meetings are invaluable. They bring thoughtful, sensible feedback when addressing ambiguous issues. Narek is always available when called upon and has taken on numerous high impact projects across the SoCal region from FFN migrations at various sites and escalations to serving as the lead engineer for the SBD6 build. Narek's contributions have been nothing short of amazing. Leading the SBD6 project, a massive site with 37 IDFs and the largest ARS in all of California and one of the largest in all of Amazon required not only technical expertise but also strong leadership. Narek lead this project from start to finish as the lead build engineer, guiding their peers and ensuring a successful build, despite very many hurdles. Narek's work ethic and positive attitude makes them a joy to work with.",
    "Narek continues to exemplify leadership abilities in his work. Narek successfully launched one of the largest ARS sites in California this year as lead Deployment Engineer. He oversaw all technical deployments for this 37 IDF site. Narek also took point on several technical pilot testing programs at SBD6 in addition to overseeing the launch of the site. Narek is comfortable with largely scoped projects and being a lead for many engineers. All of this demonstrates Narek's technical ability as well as his ability to be a leader. Based on my experience with Narek over the years I feel that Narek is due for an L5 promotion as Narek comfortably steps outside of the L4 scope on a frequent basis.",
    "Narek's super power is his ability to constantly go above and beyond for his customers. He is always looking for the best possible solution that would make the customer happy he is always researching different ways of tackling a problem in order to resolve in the most effective way possible.",
    "Narek's work as the lead build engineer during the SBD6 was instrumental in the success of the new site's launch. Narek's meticulous attention to detail is consistent with his insisting on the highest standards. This made the transition and hand off to the local team very smooth and seamless.",
    "Narek’s superpower is his exceptional technical expertise. After working closely with him for a year, I can confidently say he’s one of our top technical talents. I’ve seen him solve complex issues during builds, and his knowledge has been invaluable to the team. He's always ready to assist wherever needed, making a significant impact on our projects.",
    "While working with Narek this year, I have learned that when assigned a project or task he gives it his all and is very meticulous when it comes to his work. He is able to deliver results and make sure all stakeholders are pleased. I seen Narek take on the biggest build in Socal and hand it over with exceptional results.",
  ]
};

export const timelineData = [
  { month: "Jan", projects: 1, value: 15 },
  { month: "Feb", projects: 2, value: 28 },
  { month: "Mar", projects: 2, value: 42 },
  { month: "Apr", projects: 1, value: 55 },
  { month: "May", projects: 3, value: 70 },
  { month: "Jun", projects: 2, value: 82 },
  { month: "Jul", projects: 1, value: 88 },
  { month: "Aug", projects: 2, value: 95 },
  { month: "Sep", projects: 3, value: 105 },
  { month: "Oct", projects: 2, value: 115 },
  { month: "Nov", projects: 1, value: 120 },
  { month: "Dec", projects: 0, value: 120 }
];